
jQuery(document).ready(function ($) {

  /* THUMBNAIL SLIDER */
  var thumbSwiper = new Swiper('div#new-l1 .product-thumb-slider', {
    slidesPerView: 5,
    spaceBetween: 10,
    watchSlidesProgress: true,
    breakpoints: {
      0:   { slidesPerView: 4, spaceBetween: 15 },
      421: { slidesPerView: 5, spaceBetween: 15 },
      769: { slidesPerView: 6, spaceBetween: 18 }
    }
  });

  /* MAIN SLIDER */
  var mainSwiper = new Swiper('div#new-l1 .product-main-slider', {
    spaceBetween: 0,
    autoHeight: true,
    navigation: {
      nextEl: 'div#new-l1 .thumb-slider_arrow_wrap .swiper-button-next',
      prevEl: 'div#new-l1 .thumb-slider_arrow_wrap .swiper-button-prev'
    },
    thumbs: { swiper: thumbSwiper }
  });

  function getSelectedVariantText() {
    var $checked = $('variant-picker input[type="radio"]:checked').first();
    if (!$checked.length) return null;

    var $label = $('variant-picker label[for="' + $checked.attr('id') + '"]');
    if (!$label.length) return null;

    var $srOnly = $label.find('.sr-only').first();
    if (!$srOnly.length) return null;

    var firstNode = $srOnly.contents().filter(function () {
      return this.nodeType === 3;
    }).first();

    return $.trim(firstNode.length ? firstNode.text() : $srOnly.text());
  }

  function reorderGalleryByVariant(variantText) {
    [mainSwiper, thumbSwiper].forEach(function (swiper) {
      var $wrapper = $(swiper.el).find('.swiper-wrapper').first();
      var $slides = $wrapper.children('.swiper-slide');

      var $matched = $();
      var $unmatched = $();

      $slides.each(function () {
        var $slide = $(this);
        var alt = $.trim($slide.find('img').attr('alt') || '').toLowerCase();

        if (variantText && alt === variantText.toLowerCase()) {
          $matched = $matched.add($slide);
        } else {
          $unmatched = $unmatched.add($slide);
        }
      });

      $matched.appendTo($wrapper);
      $unmatched.appendTo($wrapper);

      swiper.update();
    });

    mainSwiper.slideTo(0, 0);
    thumbSwiper.slideTo(0, 0);

    updateVariantMeta();
    updateAccordionActive(variantText); // <-- ACTIVE ACCORDION
  }

  /* ===== VARIANT META CODE ===== */
  function updateVariantMeta() {
    var $mainSlider = $('div#new-l1 .product .product-gallery .swiper.product-main-slider');
    if (!$mainSlider.length) return;

    $mainSlider.find('.variant_meta_injected').remove();

    var $checked = $('variant-picker input[type="radio"]:checked').first();
    if (!$checked.length) return;

    var $label = $('variant-picker label[for="' + $checked.attr('id') + '"]');
    if (!$label.length) return;

    var $meta = $label.find('.variant_meta').first();
    if (!$meta.length) return;

    var $firstSlide = $mainSlider.find('.product-gallery-image').first();
    if (!$firstSlide.length) return;

    var $clone = $meta.clone()
                      .removeClass('variant_meta')
                      .addClass('variant_meta_injected');

    $firstSlide.after($clone);
  }

  /* ===== ACTIVE ACCORDION CODE ===== */
  function normalizeText(str) {
    return $.trim((str || '').toString())
            .toLowerCase()
            .replace(/["']/g, '')   
            .replace(/\s+/g, ' ');  
  }

  function updateAccordionActive(variantText) {
    var target = normalizeText(variantText);

    var $items = $('.accordion_wrap_content');
    $items.removeClass('active'); 

    if (!target) return;

    $items.each(function () {
      var $item = $(this);
      var varText = normalizeText($item.attr('var_text'));

      var isMatch = varText && (
        varText === target ||
        varText.indexOf(target) !== -1 ||
        target.indexOf(varText) !== -1
      );

      $item.toggleClass('active', isMatch);
    });
  }

  /* ===== INIT + EVENTS ===== */
  reorderGalleryByVariant(getSelectedVariantText());

  $(document).on('change', 'variant-picker input[type="radio"]', function () {
    reorderGalleryByVariant(getSelectedVariantText());
  });

});



// main product accordion
$(document).ready(function () {

  var $accordion = $('#new-l1 .product .product-info .product-accordion');

  // First accordion active on load
  $accordion.find('.accordion-item:first-child')
    .addClass('active')
    .find('.accordion-content')
    .stop(true, true)
    .slideDown(400);

  // Accordion click
  $accordion.find('.accordion-item .accordion-header').on('click', function () {

    var $header = $(this);
    var $item = $header.closest('.accordion-item');
    var $content = $item.find('.accordion-content');

    // Close other accordions
    $item
      .siblings('.accordion-item')
      .removeClass('active')
      .find('.accordion-content')
      .stop(true, true)
      .slideUp(400);

    // Toggle current accordion
    $item.toggleClass('active');

    $content
      .stop(true, true)
      .slideToggle(400);

  });

});

// price update 

function updateVariantPrice() {
    var $selectedVariant = $('.variant-picker__option-values input[type="radio"]:checked');
    var $priceElement = $selectedVariant.next('label').find('.varinat_price');

    if (!$priceElement.length) return;

    var price = $priceElement.attr('varinat_price');
    var comparePrice = $priceElement.attr('comp_price');
    var savePrice = $priceElement.attr('save_price');

    $('.button-price__current').text(price);
    $('.button-price__compare').text(comparePrice);
    $('.save-price').text(savePrice);

    console.log('Price:', price);
    console.log('Compare Price:', comparePrice);
    console.log('Save Price:', savePrice);
}

// On page load
$(document).ready(function () {
    updateVariantPrice();
});

// On variant change
$(document).on('change', '.variant-picker__option-values input[type="radio"]', function () {
    updateVariantPrice();
});